import React from 'react';

import { memoryNameDescription } from '../../../../SidekickActionsConstants';
import InputControl from './InputControl';
import { Row } from './Layout';

const MemoryNameInput = props => {
  return (
    <Row>
      <InputControl
        {...props}
        typeSpec={{
          ...props.typeSpec,
          prompt: 'Memory Name',
          description: memoryNameDescription,
        }}
      />
    </Row>
  );
};

export default MemoryNameInput;
